export interface NavItem {
  route: string;
  label: string;
  short: string;
  icon: string;
  iconActive: string;
  exact: boolean;
}

/** Main sections, shared by the desktop top bar and the phone tab bar. */
export const NAV_ITEMS: NavItem[] = [
  {route: '/admin', label: 'Home', short: 'Home', icon: 'bi-house', iconActive: 'bi-house-fill', exact: true},
  {route: '/admin/topic', label: 'Topics', short: 'Topics', icon: 'bi-journal-text', iconActive: 'bi-journal-text', exact: false},
  {route: '/admin/task', label: 'Tasks', short: 'Tasks', icon: 'bi-check2-square', iconActive: 'bi-check-square-fill', exact: false},
  {route: '/admin/reminder', label: 'Reminders', short: 'Reminders', icon: 'bi-alarm', iconActive: 'bi-alarm-fill', exact: false},
  {route: '/admin/document', label: 'Documents', short: 'Docs', icon: 'bi-file-earmark-text', iconActive: 'bi-file-earmark-text-fill', exact: false},
  {route: '/admin/tag', label: 'Tags', short: 'Tags', icon: 'bi-tags', iconActive: 'bi-tags-fill', exact: false},
];
